var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirCondition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 1.68652H14.3346",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00065 0.336914C0.82384 0.336914 0.654271 0.40802 0.529247 0.534591C0.404222 0.661161 0.333984 0.832827 0.333984 1.01182V6.4111C0.333984 6.5901 0.404222 6.76177 0.529247 6.88834C0.654271 7.01491 0.82384 7.08601 1.00065 7.08601H2.00065V5.73619H14.0007V7.08601H15.0007C15.1775 7.08601 15.347 7.01491 15.4721 6.88834C15.5971 6.76177 15.6673 6.5901 15.6673 6.4111V1.01182C15.6673 0.832827 15.5971 0.661161 15.4721 0.534591C15.347 0.40802 15.1775 0.336914 15.0007 0.336914H1.00065Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00195 7.08594H13.002",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 4.38672H9.33464",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33464 14.1729L8.0013 15.5227L6.66797 14.1729",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8522 13.416L12.0014 15.1851L10.2539 14.3238",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.668 11.1357V13.1605H13.668",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00195 8.09863V15.5226",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.668 8.09863C13.1008 10.07 14.1534 11.8461 15.668 13.1605",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.334 8.09863C10.5553 10.3396 11.0519 12.5439 11.8123 14.6604L12.0007 15.1852",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15039 13.416L4.00122 15.1851L5.74872 14.3238",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.333984 11.1357V13.1605H2.33398",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 8.09863C2.90118 10.07 1.84853 11.8461 0.333984 13.1605",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66862 8.09863C5.44734 10.3396 4.95072 12.5439 4.19029 14.6604L4.00195 15.1852",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirCondition);
export default __webpack_public_path__ + "static/media/airCondition.6a6b43f6.svg";
export { ForwardRef as ReactComponent };